import React from 'react';
import List from '../../../UI/List/List';
import UsersItem from './UsersItem/UsersItem';
import {
	withStyles,
} from '@material-ui/core';
import usersFields from './usersFields';
import styles from './UsersList.styles';
import classnames from 'classnames';

const UsersList = ({
	anchorEl,
	classes,
	className,
	currentScreenSize,
	getMoreRows,
	onDelete,
	onEdit,
	onEnable,
	onResetPassword,
	onSelect,
	roles,
	selected,
	setAnchorEl,
	users,
}) => {

	const usersItems = !!users
		&& users.length > 0
		&& users
			.sort((a, b) => {

				if (!a || !b) {
					return 0;
				}

				return ('' + a.name).localeCompare(b.name);
			})
			.map(user => (
				<UsersItem
					anchorEl={anchorEl}
					key={user.code}
					onDelete={onDelete}
					onEdit={onEdit}
					onEnable={onEnable}
					onResetPassword={onResetPassword}
					onSelect={onSelect}
					roles={roles}
					selected={selected === user.code}
					setAnchorEl={setAnchorEl}
					user={user}
				/>
			));

	const list = (
		<List
			className={classnames(classes.root, className)}
			getMoreRows={getMoreRows}
			headerFields={usersFields(currentScreenSize)}
		>
			{usersItems}
		</List>
	);

	return list;
};

export default withStyles(styles)(UsersList);